import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import React, { memo } from "react";

const ClassIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 25 24"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <g clipPath="url(#clip0_1384_4124)">
        <g clipPath="url(#clip1_1384_4124)">
          <path
            d="M7.02153 11.672C7.13778 11.3 7.13778 10.9512 7.13778 10.9512C7.13778 8.44021 4.69653 8.50996 4.69653 8.50996C2.76678 8.50996 2.39478 10.1607 2.32503 10.4397C2.18553 11.5092 2.83653 12.3695 2.83653 12.3695C1.11603 12.974 0.39528 15.5315 0.25578 16.1825C0.11628 17.3217 0.97653 17.4147 0.97653 17.4147H3.04578L2.55753 16.694H0.97653C0.97653 16.694 0.83703 16.6242 1.11603 15.764C1.32528 15.113 1.86003 12.788 4.37103 12.7182C4.37103 12.7182 2.85978 11.9975 2.99928 10.7885C2.99928 10.5792 3.20853 9.20746 4.78953 9.20746C4.78953 9.20746 6.44028 9.27721 6.44028 10.928C6.44028 11.1372 6.51003 11.3465 6.30078 11.6487L7.02153 11.672Z"
            fill="#243648"
            stroke="#243648"
            strokeWidth="0.3875"
          />
          <path
            d="M16.2517 11.672C16.1355 11.3 16.1355 10.9512 16.1355 10.9512C16.1355 8.44021 18.5767 8.50996 18.5767 8.50996C20.5065 8.50996 20.8785 10.1607 20.9482 10.4397C21.0877 11.5092 20.4367 12.3695 20.4367 12.3695C22.1572 12.9507 22.878 15.5315 23.0175 16.1592C23.157 17.2985 22.2967 17.3915 22.2967 17.3915H20.2275L20.739 16.6475H22.32C22.32 16.6475 22.4595 16.5777 22.1805 15.7175C21.9712 15.0665 21.4365 12.7415 18.9255 12.6717C18.9255 12.6717 20.4367 11.951 20.2972 10.742C20.2972 10.5327 20.088 9.16096 18.507 9.16096C18.507 9.16096 16.8562 9.23071 16.8562 10.8815C16.8562 11.0907 16.7865 11.3 16.9957 11.6022L16.2517 11.672Z"
            fill="#243648"
            stroke="#243648"
            strokeWidth="0.3875"
          />
          <path
            d="M11.6251 4.11523C9.71864 4.11523 8.16089 5.67298 8.16089 7.57948C8.16089 9.48598 9.71864 11.0437 11.6251 11.0437C13.5316 11.0437 15.1126 9.48598 15.1126 7.57948C15.1126 5.67298 13.5549 4.11523 11.6251 4.11523ZM11.6251 10.3462C10.1139 10.3462 8.85839 9.11398 8.85839 7.57948C8.85839 6.06823 10.0906 4.81273 11.6251 4.81273C13.1596 4.81273 14.3919 6.04498 14.3919 7.57948C14.3919 9.09073 13.1596 10.3462 11.6251 10.3462Z"
            fill="#243648"
            stroke="#243648"
            strokeWidth="0.3875"
          />
          <path
            d="M11.6484 11.6251C6.06837 11.6251 4.62687 16.6471 4.48737 17.2051C4.13862 19.1348 6.13812 19.1348 6.13812 19.1348C6.13812 19.1348 15.6706 19.1348 17.2284 19.1348C18.8094 19.1348 18.8094 17.9258 18.8094 17.5538C17.4609 11.2763 11.6484 11.6251 11.6484 11.6251ZM16.9959 18.4606C16.0659 18.4606 6.32412 18.4606 6.32412 18.4606C6.32412 18.4606 5.11512 18.3908 5.18487 17.5306C5.25462 16.9493 6.46362 12.5086 11.4159 12.2993C11.4159 12.2993 16.8564 12.0203 18.0654 17.6003C18.0654 17.8793 17.9259 18.4606 16.9959 18.4606Z"
            fill="#243648"
            stroke="#243648"
            strokeWidth="0.3875"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1384_4124">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_1384_4124">
          <rect width="23.25" height="23.25" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default memo(ClassIcon);
